export default {
  ar() {
    return {
      added: '{name} إضافة إلي عربة التسوق',
      addOns: 'الإضافات',
      item: 'السلعة {startCount} من {total}',
      items: 'السلع ({startCount} - {endCount}) من {total}'
    }
  },
  de() {
    return {
      added: '{name} zum Warenkorb hinzugefügt',
      addOns: 'Add-Ons',
      item: 'Artikel {startCount} von {total}',
      items: 'Artikel ({startCount} - {endCount}) von {total}'
    }
  },
  en() {
    return {
      added: '{name} added to cart',
      addOns: 'Add-Ons',
      item: 'Item {startCount} of {total}',
      items: 'Items ({startCount} - {endCount}) of {total}'
    }
  },
  enGB() {
    return {
      added: '{name} added to basket',
      addOns: 'Add-Ons',
      item: 'Item {startCount} of {total}',
      items: 'Items ({startCount} - {endCount}) of {total}'
    }
  },
  esMX() {
    return {
      added: '{name} añadido al carrito',
      addOns: 'Adicionales',
      item: 'Artículo {startCount} de {total}',
      items: 'Artículos ({startCount} - {endCount}) de {total}'
    }
  },
  fr() {
    return {
      added: '{name} ajouté au panier',
      addOns: 'Services supplémentaires',
      item: 'Article {startCount} sur {total}',
      items: 'Articles ({startCount} à {endCount}) sur {total}'
    }
  },
  it() {
    return {
      added: '{name} aggiunto al carrello',
      addOns: 'Extra',
      item: 'Articolo {startCount} di {total}',
      items: 'Articoli ({startCount} - {endCount}) di {total}'
    }
  },
  ja() {
    return {
      added: '{name}がカートに追加されました',
      addOns: 'アドオン',
      item: '{total}の内アイテム{startCount}',
      items: '{total}の内、 ({startCount} ～ {endCount}) 項目'
    }
  },
  pl() {
    return {
      added: '{name} dodano do koszyka',
      addOns: 'rozszerzenia',
      item: 'pozycja {startCount} z {total}',
      items: 'pozycje ({startCount} - {endCount}) z {total}'
    }
  },
  zhCN() {
    return {
      added: '{name} 添加至购物车',
      addOns: '附加',
      item: '{total}的{startCount}项目',
      items: '{total}项目的 ({startCount} - {endCount})'
    }
  }
}
